import { SvgIcon, SvgIconProps } from '@mui/material';

const RemarkIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.923 20v-1.538l4.754-4.68 1.562 1.538L13.486 20h-1.563ZM4 15.45v-1.3h6.602v1.3H4Zm15.186-1.062-1.563-1.538.638-.628a.63.63 0 0 1 .463-.174.63.63 0 0 1 .462.174l.638.628a.61.61 0 0 1 .176.455.61.61 0 0 1-.176.455l-.638.628ZM4 11.875v-1.3h10.344v1.3H4ZM4 8.3V7h10.344v1.3H4Z"
    />
  </SvgIcon>
);
export default RemarkIcon;
